<template>
  <Layout>
    <div class="is-flex clients-point">
      <Card class="w-full">
        <template slot="header">
          <div class>
            <h3 class="is-size-4 has-text-weight-bold">Actualizar Cliente</h3>
          </div>
        </template>
        <template slot="content">
          <section>
            <b-tabs v-model="activeTab" :animated="false">
              <b-tab-item label="Información">
                <div class="pb-6">
                  <b-field label="N° documento">
                    <b-input :value="data.num_document" disabled></b-input>
                  </b-field>
                  <b-field
                    label="Nombre"
                    :type="{ 'is-danger': $v.data.first_name.$error }"
                    :message="[
                      {
                        'Campo requerido':
                          !$v.data.first_name.required &&
                          $v.data.first_name.$error
                      }
                    ]"
                  >
                    <b-input v-model="data.first_name"></b-input>
                  </b-field>
                  <b-field
                    label="Apellidos"
                    :type="{ 'is-danger': $v.data.last_name.$error }"
                    :message="[
                      {
                        'Campo requerido':
                          !$v.data.last_name.required &&
                          $v.data.last_name.$error
                      }
                    ]"
                  >
                    <b-input v-model="data.last_name"></b-input>
                  </b-field>
                  <b-field label="Fecha de nacimiento">
                    <b-datepicker
                      v-model="birth_date"
                      placeholder="Seleccione una fecha"
                      size="is-regular"
                      locale="es-PE"
                      icon="calendar-day"
                      :max-date="new Date()"
                    ></b-datepicker>
                  </b-field>
                  <b-field
                    label="Email"
                    :type="{ 'is-danger': $v.data.email.$error }"
                    :message="[
                      {
                        'Campo requerido':
                          !$v.data.email.required && $v.data.email.$error,
                        'Email inválido':
                          !$v.data.email.email && $v.data.email.$error
                      }
                    ]"
                  >
                    <b-input v-model="data.email"></b-input>
                  </b-field>
                  <b-field
                    label="Teléfono"
                    :type="{ 'is-danger': $v.data.phone.$error }"
                    :message="[
                      {
                        'Campo requerido':
                          !$v.data.phone.required && $v.data.phone.$error
                      }
                    ]"
                  >
                    <b-input v-model="data.phone"></b-input>
                  </b-field>
                  <b-field label="Activo">
                    <b-switch
                      v-model="data.is_active"
                      type="is-success"
                    ></b-switch>
                  </b-field>
                </div>
              </b-tab-item>
            </b-tabs>
          </section>
        </template>
      </Card>
      <Aside>
        <Button
          variant="main"
          :spinner="loading"
          @click.native="updateClient()"
          block
          >Guardar</Button
        >
        <Button
          tag="router-link"
          :to="{ name: 'puntos-clientes' }"
          variant="gray"
          block
          class="mt-2"
          >Cancelar</Button
        >
      </Aside>
    </div>
  </Layout>
</template>

<script>
// @ is an alias to /src
import { required, email } from "vuelidate/lib/validators";
import Layout from "@/components/Layout";
import Card from "@/components/base/Card";
import Aside from "@/components/Aside";
import Button from "@/components/form/Button";
import ClientPointService from "@/services/puntos/ClientPointService";
import formatDate from "@/mixins/formatDate";
export default {
  name: "CompanyInfo",
  components: {
    Layout,
    Card,
    Aside,
    Button
  },
  mixins: [formatDate],
  data() {
    return {
      activeTab: 0,
      data: {
        is_active: true,
        email: "",
        first_name: "",
        last_name: "",
        phone: "",
        num_document: "",
        birth_date: ""
      },
      formData: new FormData(),
      loading: false,
      birth_date: null
    };
  },
  validations: {
    data: {
      email: { required, email },
      first_name: { required },
      last_name: { required },
      phone: { required },
      num_document: { required }
    }
  },
  watch: {
    birth_date: function(val) {
      this.data.birth_date = this.formatDateToString(val);
    }
  },
  mounted() {
    this.getClient();
  },
  methods: {
    async getClient() {
      this.loading = true;
      try {
        const { data } = await ClientPointService.getClient(
          this.$route.params.id
        );
        this.data = data.client;
        if (this.data.birth_date) {
          this.birth_date = this.formatStringToDate(this.data.birth_date);
        }
      } catch (error) {
        this.showAlert("D", "Ocurrió un error.");
        this.$router.push({ name: "puntos-clientes" });
      } finally {
        this.loading = false;
      }
    },
    showAlert(type, msg) {
      this.$store.commit("settings/SET_ALERT", {
        isAlert: true,
        type,
        msg
      });
    },
    async updateClient() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.showAlert("D", "Complete los campos requeridos.");
        return;
      }
      this.loading = true;
      try {
        await ClientPointService.putClient(this.$route.params.id, this.data);
        this.loading = false;
        this.showAlert("S", "Se guardó correctamente.");
        this.$router.push({ name: "puntos-clientes" });
      } catch (error) {
        this.loading = false;
        this.showAlert("D", "Ocurrió un error.");
      }
    }
  }
};
</script>

<style>
.clients-point span.icon.is-left {
  padding-top: 0.7rem;
}
</style>
